/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { MktuClass } from './MktuClass'
import {
  MktuClassFromJSON,
  MktuClassFromJSONTyped,
  MktuClassToJSON,
} from './MktuClass'

/**
 *
 * @export
 * @interface GetClasses200Response
 */
export interface GetClasses200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetClasses200Response
   */
  status: boolean
  /**
   *
   * @type {Array<MktuClass>}
   * @memberof GetClasses200Response
   */
  data: Array<MktuClass>
}

/**
 * Check if a given object implements the GetClasses200Response interface.
 */
export function instanceOfGetClasses200Response(
  value: object
): value is GetClasses200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetClasses200ResponseFromJSON(
  json: any
): GetClasses200Response {
  return GetClasses200ResponseFromJSONTyped(json, false)
}

export function GetClasses200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetClasses200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(MktuClassFromJSON),
  }
}

export function GetClasses200ResponseToJSON(
  value?: GetClasses200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(MktuClassToJSON),
  }
}
